<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-card :header="headerTitle" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :scrollBottom="scrollBoolean"
                        :scrollTop="scrollBoolean"
                        :paginate="false"
                        :exportable="false" 
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :rowsCount="rowsCount"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>

                    <b-btn class="btn btn-dark mt-3 mr-2" @click="returnToProgressSettings">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_settings')}}
                    </b-btn>

                    <span v-if="returnedFrom">
                        <b-btn v-if="this.$store.getters.hasPermission(['project_progress_settings_steps'], ['create'])" class="btn btn-default mt-3 mr-2" @click="onAddRow">
                            <i class="fa fa-plus-circle mr-1"></i> {{$t('general.projects.progress_setting_steps.create_button')}}
                        </b-btn>
                    </span>
                </b-card>
            </div>
        </div>

        <progress-setting-steps-modal
            ref="progressSettingStepsModal"
            :section="section"
            :tableName="tableName"
            :tableNameTranslated="tableNameTranslated"
            :finalSteps.sync="finalSteps"
            @checkSteps="checkSteps"
            @onLoadTable="onLoadTable"
        >
        </progress-setting-steps-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import ProgressSettingStepsModal from '@/components/global/modals/ProgressSettingStepModal.vue';

export default {
    name: 'progress_setting_steps_table',
    components: {
        DataTable,
        ConfirmDialog,
        ProgressSettingStepsModal,
    },
    props: {
        section: {
            type: String,
            required: true,
        },
    },
    data() {
         return {
            tableName: 'progress_setting_step',
            tableNameTranslated: Vue.i18n.translate('general.projects.progress_setting_steps.title_modal'),
            row: null,
            scrollBoolean: false,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            actionTitleDelete: '',
            headerTitle: '',

            returnedFrom: false,
            returnedSteps: 0,
            rowSteps: [],
            finalSteps: [],
            steps: [],
            getData: {
                rowData: []
            },
            columnData: [],
        }
    },
    mounted() {
        this.getTableColumns();
    },
    computed: {
        progress_settings: {
            get: function () {
                let progress_settings = this.$store.getters.getProgressSettings;
                return progress_settings;
            }
        }
    },
    watch: {
        progress_settings: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    methods: {
        getTableColumns () {
            switch (this.section) {
                case 'piping':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_detail_calculation_work_value'),
                            field: 'step_detail_calculation_work_value',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_detail_calculation_work_value'),
                            field: 'recovery_1_step_detail_calculation_work_value',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_detail_calculation_work_value'),
                            field: 'recovery_2_step_detail_calculation_work_value',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_weight_work_status'),
                            field: 'step_weight_work_status',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_detail_weight'),
                            field: 'recovery_1_step_detail_weight',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_detail_weight'),
                            field: 'recovery_2_step_detail_weight',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.step_dia_inch_total'),
                            field: 'step_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_dia_inch_prefabrication'),
                            field: 'step_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_dia_inch_erection'),
                            field: 'step_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.recovery_1_step_dia_inch_total'),
                            field: 'recovery_1_step_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_dia_inch_prefabrication'),
                            field: 'recovery_1_step_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_dia_inch_erection'),
                            field: 'recovery_1_step_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.recovery_2_step_dia_inch_total'),
                            field: 'recovery_2_step_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_dia_inch_prefabrication'),
                            field: 'recovery_2_step_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_dia_inch_erection'),
                            field: 'recovery_2_step_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.step_bw_dia_inch_total'),
                            field: 'step_bw_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_bw_dia_inch_prefabrication'),
                            field: 'step_bw_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_bw_dia_inch_erection'),
                            field: 'step_bw_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.recovery_1_step_bw_dia_inch_total'),
                            field: 'recovery_1_step_bw_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_bw_dia_inch_prefabrication'),
                            field: 'recovery_1_step_bw_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_step_bw_dia_inch_erection'),
                            field: 'recovery_1_step_bw_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                        {//calculated
                            label: Vue.i18n.translate('table.recovery_2_step_bw_dia_inch_total'),
                            field: 'recovery_2_step_bw_dia_inch_total',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_bw_dia_inch_prefabrication'),
                            field: 'recovery_2_step_bw_dia_inch_prefabrication',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_2_step_bw_dia_inch_erection'),
                            field: 'recovery_2_step_bw_dia_inch_erection',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'equipment':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_equipment'),
                            field: 'steps_equipment',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_equipment'),
                            field: 'recovery_1_equipment',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'ei':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_ei'),
                            field: 'steps_ei',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_ei'),
                            field: 'recovery_1_ei',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'steelstructure':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_steelstructure'),
                            field: 'steps_steelstructure',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_steelstructure'),
                            field: 'recovery_1_steelstructure',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'civil':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_civil'),
                            field: 'steps_civil',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_civil'),
                            field: 'recovery_1_civil',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'painting':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_painting'),
                            field: 'steps_painting',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_painting'),
                            field: 'recovery_1_painting',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
                case 'insulation':
                    this.columnData = [
                        {
                            label: Vue.i18n.translate('misc.actions'),
                            width: '90px',
                            showDeleteButton: true,
                            showEditButton: true,
                        },
                        {
                            label: Vue.i18n.translate('table.step_no'),
                            field: 'step_no',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_date'),
                            field: 'step_date',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.step_calendar'),
                            field: 'step_calendar',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.steps_insulation'),
                            field: 'steps_insulation',
                            numeric: false,
                            html: false,
                        },
                        {
                            label: Vue.i18n.translate('table.recovery_1_insulation'),
                            field: 'recovery_1_insulation',
                            numeric: false,
                            html: false,
                        },
                    ];
                break;
            }

            this.getSection();
        },
        getSection () {
            this.headerTitle = Vue.i18n.translate('general.projects.progress_setting_steps_'+ this.section +'.title');
            var that = this;
            Object.keys(that.progress_settings).forEach(key => {
                if (typeof that.progress_settings[key].section != 'undefined') {
                    if (that.progress_settings[key].section == that.section && (that.$store.state.key != that.progress_settings[key].code)) {
                        that.$router.push('/project/'+that.$route.params.id+'/progress_settings');
                    }
                }
            });

            this.getInfos();
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        checkSteps (response) {
            this.finalSteps.splice(this.finalSteps.indexOf(response.data.step_no), 1);
            if (this.finalSteps.length == 0) {
                this.returnedFrom = false;
            } else {
                this.returnedFrom = true;
            }
        },
        async onLoadTable () {
            return new Promise((resolve, reject) => {
                let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[progress_setting_id]=' + this.$route.params.id2 + '&search=' + this.searchInput + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&get_all=1&filters[section]=' + this.section).get();
                data.then(response => {
                    if (!response.isError) {
                        this.rowsCount       = response.pagination.totalEntries;
                        this.getData.rowData = response.data;
                        this.tableLoaded     = true;
                        this.scrollBoolean   = (this.getData.rowData.length > 10)
                        resolve();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                        resolve();
                    }
                });
            });
        },
        async getSteps () {
            return new Promise((resolve, reject) => {
                if (typeof this.$route.params.id2 == 'undefined') {
                    this.$router.push('/project/'+this.$route.params.id+'/progress_settings');
                } else {
                    http.route('progress_setting/' + this.$route.params.id2).get()
                    .then(response => {
                        if (!response.isError) {
                            this.returnedSteps = response.data.value;
                            resolve();
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                            resolve();
                        }
                    });
                }
            });
        },
        async getDatas () {
            await this.onLoadTable();
            await this.getSteps();
        },
        getInfos () {
            this.getDatas().then(res => {
                if (this.returnedSteps > 0) {
                    this.getData.rowData.forEach(field => {
                        // console.log(this.finalSteps);
                        // if (this.finalSteps.includes(field.step_no)) {
                            this.rowSteps.push(field.step_no);
                        // }
                    });

                    for (let i = 0; i < this.returnedSteps; i++) {
                        this.steps.push(i + 1);
                    }
                    this.finalSteps = this.steps.filter(x => !this.rowSteps.includes(x));
                    if (this.steps.length == 0 || this.finalSteps.length == 0) {
                        this.returnedFrom = false;
                    } else {
                        this.returnedFrom = true;
                    }
                } else {
                    this.steps = [];
                    this.returnedFrom = false;
                }
            });
        },
        onAddRow () {
            this.$refs.progressSettingStepsModal.onAddRow();
        },
        onEditRow (row) {
            this.$refs.progressSettingStepsModal.onEditRow(row);
        },
        onDeleteRow (row, index) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        this.finalSteps.push(this.row.step_no);
                        this.finalSteps.sort();
                        if (this.finalSteps.length == 0) {
                            this.returnedFrom = false;
                        } else {
                            this.returnedFrom = true;
                        }
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        returnToProgressSettings () {
            this.$router.push('/project/'+this.$route.params.id+'/progress_settings');
        },
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/progress_settings/progress_settings_steps/progress_settings_steps_table.vue